import { PORTAL_NAV } from '../../../constants/portals';

// Commit the whole destination only after the existing unsaved-work guard agrees.
export function selectProjectWorkspace(view, { canAccess, close, guard, projects, navigate }) {
  const valid = PORTAL_NAV.find(p => p.key === 'projects')?.subsections?.some(s => s.projectsView === view);
  if (!valid || !canAccess()) return false;
  close();
  const proceed = () => {
    if (!canAccess()) return;
    projects.setProjectsView(view);
    navigate();
  };
  if (!guard(proceed)) proceed();
  return true;
}
